export interface PostHogClient {
  capture: (eventName: string, properties?: Record<string, unknown>) => void;
  identify: (userId: string, traits?: Record<string, unknown>) => void;
  reset: () => void;
}

export function getPostHogAppName(client: string, stage: string): string {
  return `${client}-${stage}`.replace('Premialab', 'core');
}

export function capturePostHogEvent(
  instance: PostHogClient | null,
  isEnabled: boolean,
  eventName: string,
  properties?: Record<string, unknown>,
): void {
  if (!isEnabled || !instance) {
    return;
  }

  try {
    instance.capture(eventName, properties);
  } catch (error) {
    console.error('Failed to capture PostHog event:', error);
  }
}

export function identifyPostHogUser(
  instance: PostHogClient | null,
  isEnabled: boolean,
  userId: string,
  traits?: Record<string, unknown>,
): void {
  if (!isEnabled || !instance) {
    return;
  }

  try {
    instance.identify(userId, traits);
  } catch (error) {
    console.error('Failed to identify PostHog user:', error);
  }
}
